<script lang="ts" setup>
import type { FormSubmitEvent } from '@primevue/forms'

const emit = defineEmits<{
  complete: [contact: components['schemas']['Contact']]
}>()
const loading = ref<boolean>(false)
const strategy =
  ref<components['schemas']['ConversationStrategyEnum']>('whatsapp')
const toast = useToast()

const onFieldChange = (
  field: string,
  value: components['schemas']['ConversationStrategyEnum']
) => {
  if (field !== 'strategy') return
  return (strategy.value = value)
}

const handleSubmit = async ({ states, valid, values }: FormSubmitEvent) => {
  if (!valid) return

  loading.value = true

  const { $api } = useNuxtApp()
  await $api<components['schemas']['Contact']>('/support/contact/', {
    method: 'POST',
    body: values,
  })
    .then((response) => emit('complete', response))
    .catch((error) => processFormErrors(error, toast, states))
    .finally(() => (loading.value = false))
}
</script>

<template>
  <DynamicForm
    :initial-values="{
      strategy,
    }"
    :fields="[
      {
        as: 'InputText',
        name: 'first_name',
        label: 'Nombres',
        schema: yup.string().required().label('Nombres'),
      },
      {
        as: 'InputText',
        name: 'last_name',
        label: 'Apellidos',
        schema: yup.string().required().label('Apellidos'),
      },
      {
        as: 'InputText',
        name: 'phone_number',
        label: 'Celular',
        schema: yup.string().required().label('Celular'),
      },
      {
        as: 'InputText',
        name: 'email',
        label: 'Email',
        schema: yup.string().email().required().label('Email'),
      },
      {
        as: 'Textarea',
        name: 'content',
        label: 'Mensaje',
        schema: yup.string().required().label('Mensaje'),
      },
    ]"
    :loading="loading"
    :submit-props="{
      icon: 'pi pi-send',
      label: 'Enviar',
    }"
    @submit="handleSubmit"
  />
</template>
